import uniq from 'hs-lodash/uniq';
import get from 'immutable-less/transmute/get';
import isEmpty from 'transmute/isEmpty';
import isEqual from 'hs-lodash/isEqual';
import isNull from 'transmute/isNull';
import { OrderedSet, List } from 'immutable';
import * as ListTypes from 'automation-ui-flow-core/flow/ListTypes';
// temporary fix for flows that are missing an empty
// OR Wrapper
// jira issue: https://issues.hubspotcentral.com/browse/WORKFLOWS-1482
export const ensureEmptyORWrapper = (listTypes, filterBranch) => {
  const {
    filterBranchOperator,
    filterBranchType
  } = filterBranch;
  if (!isEqual(listTypes, [ListTypes.ENROLLMENT_LIST]) || filterBranchOperator === 'OR' && filterBranchType === 'OR') {
    return filterBranch;
  }
  const newFilterBranch = Object.assign({}, filterBranch, {
    filterBranchOperator: 'OR',
    filterBranchType: 'OR',
    filterBranches: filterBranch ? [filterBranch] : [],
    filters: []
  });
  return newFilterBranch;
};
export function isFilterEmpty(value) {
  if (!value) {
    return true;
  }
  if (Array.isArray(value)) {
    return !value.length;
  }
  if (List.isList(value)) {
    return !value.size;
  }
  if (isEmpty(value)) {
    return true;
  }
  return isEmpty(get('filterBranches', value)) && isEmpty(get('filters', value));
}

/**
 * Checks if the given filter is the default classic filter branch ([[]])
 * that will only be present when saving a list branch without adding any filters
 * @param {filterBranch} value
 * @returns boolean
 */
export function isClassicDefaultFilterBranch(value) {
  if (!value) {
    return false;
  }
  if (Array.isArray(value)) {
    if (value.length === 1) {
      return !!(value[0] && !value[0].length);
    }
  } else if (List.isList(value)) {
    if (value.size === 1) {
      return !!(value.first() && !value.first().size);
    }
  }
  return false;
}

/**
 * Checks if the filter is the platform default filter branch (null).
 * This is to differentiate in places where we simply use isFilterEmpty since it will
 * always return true.
 * @param {filterBranch} value
 * @returns bool
 */
export function isPlatformDefaultFilterBranch(value) {
  return isNull(value);
}

/**
 * Checks if there are duplicate filters in the given listBranches
 * @param {*} listBranches
 * @returns bool
 */
export function hasDuplicateFilters(listBranches) {
  return !!(listBranches && listBranches.map(({
    id
  }) => id).some((value, index, self) => {
    return self.toArray().indexOf(value) !== index;
  }));
}
export function isRVDefaultFilterBranch(value, isClassicWorkflow) {
  return isClassicWorkflow ? isClassicDefaultFilterBranch(value) : isPlatformDefaultFilterBranch(value);
}

/*
Quick and dirty implementation of a deep object scan for
the property "objectTypeId", to identify unique filter families
used within a list.
This will be replaced by a mechanism being implemented here:
https://git.hubteam.com/HubSpot/CRM-Issues/issues/1217
*/
export function getFilterFamilies(value, key, memo = []) {
  if (Array.isArray(value) || List.isList(value)) {
    value.forEach(entry => {
      if (typeof entry === 'object') {
        const ret = getFilterFamilies(entry, key, memo);
        if (typeof ret !== 'object') {
          memo.push(ret);
        }
      }
    });
  } else if (typeof value === 'object') {
    if (value !== null) {
      let _value = value;
      if (value.toJS) {
        _value = value.toJS();
      }
      Object.keys(_value).forEach(k => {
        const v = _value[k];
        const ret2 = getFilterFamilies(v, k, memo);
        if (ret2 && typeof ret2 !== 'object') {
          memo.push(ret2);
        }
      });
    }
  } else if (typeof value === 'string') {
    if (key === 'objectTypeId') {
      return value;
    }
  }
  return uniq(memo);
}
export const getUniqueFilters = filters => {
  return OrderedSet(filters.flatten(1)).toList();
};